import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-bg text-fg">
      <p className="text-5xl font-bold text-muted">404</p>
      <p className="text-lg">Страница не найдена</p>
      <Link to="/" className="text-accent hover:underline">
        На главную
      </Link>
    </div>
  );
}
